const config = {
    couchdb_final_docs: 'https://fuel.api.tag-ip.com/fuel/finaldocument/',
    couchdb_jsonapi: 'https://fuel.api.tag-ip.com/fuel/api/',
    clientId: 'c0d63a8030e5a2b9789242546e382bdbef98fad5e02dbb0f0e55b1a1df0c8e43',
    redirect_uri: 'https://fuel.tag-ip.com/',
    graphql_api: 'https://graphql.tag-ip.com/v1/graphql',
    graphql_ws: 'wss://graphql.tag-ip.com/v1/graphql',
    pi_url: 'https://home-legacy.tag-ip.com',
    authRequest: 'https://auth.tag-ip.com/oauth/authorize',
    tokenRequest: 'https://auth.tag-ip.com/oauth/token?client_id=c0d63a8030e5a2b9789242546e382bdbef98fad5e02dbb0f0e55b1a1df0c8e43&client_secret=dec268a6211863ca6bd21ec6054db6b45333c3adb5a2b1d528864ef181def83f',
    client_secret: 'dec268a6211863ca6bd21ec6054db6b45333c3adb5a2b1d528864ef181def83f',
    salt_url: 'https://auth.tag-ip.com',
    pi_graphql_api: 'https://home-legacy.tag-ip.com/api/graphiql',
    pi_graphql_ws: 'wss://home-legacy.tag-ip.com/socket',
    omega_graphql_api: 'https://omega.tag-ip.com/api',
    omega_graphql_ws: 'wss://omega.tag-ip.com/socket',
    chartMaxVolumeMargin: 50,
    event_validation_day_difference: 4,
    api_key: 'lU7jMZt9Pi6CpsVd4h44JPeX'
}
export default config